export type TError = {
  hasError: boolean;
  dataError?: any;
  message?: string;
}

export type TGIdNameData = {
  id: number;
  name?: string
}

export const TDataListInitialValue = {
  data: [],
  count: 0
}

export type TDataList = {
  data?: any[];
  count?: number;
}

export type TGQuantityData = {
  magnitude: number;
  unit: string;
}


export type DefaultParams = {
  pageNumber?: number | null;
  perPage?: number | null;
  sort?: string | null;
  field?: string | null;
  search?: string | null;
  fromDate?: string | null;
  toDate?: string | null;
}

export const defaultParamsInitialValues = {
  pageNumber: 0,
  perPage: 10,
  sort: null,
  field: null,
  search: null,
  fromDate: null,
  toDate: null,
}